<template>
  <div class="overflow-x-hidden">
    <!-- data -->
    <div class="calendar-container pt-2">
      <div class="calendar-header">
        <button @click="prevMonth" class="nav-button ml-2">
          <ChevronDownIcon class="h-7 w-7 text-gray-400 rotate-90" />
        </button>
        <span class="month-year">{{ monthYear }}</span>
        <button @click="nextMonth" class="nav-button mr-2">
          <ChevronDownIcon class="h-7 w-7 text-gray-400 -rotate-90" />
        </button>
      </div>
    </div>

    <!-- cards -->
    <section>
      <div
        class="w-full mb-1"
        :class="[
          isMobile
            ? 'grid gap-4 gap-y-2 text-sm grid-cols-2'
            : 'flex justify-center font-semibold',
        ]"
      >
        <CardsStatistics
          v-for="(item, index) in cards"
          :key="index"
          :label="item.label"
          :value="item.count"
          :resolvidos="item.label == 'Resolvido' ? true : false"
          :controlados="item.label == 'Controlado' ? true : false"
          :cancelados="item.label == 'Cancelado' ? true : false"
          :criticos="item.label == 'Crítico' ? true : false"
        />
      </div>
    </section>

    <div class="w-full block md:flex justify-center mt-2">
      <!-- piramide -->
      <section class="me-2">
        <div
          class="max-w-sm w-full bg-white rounded-lg shadow-sm border block pb-2"
        >
          <div class="flex justify-between border-gray-200 border-b -mb-10">
            <div class="flex justify-center items-center w-full text-center">
              <h5
                class="text-xl font-bold leading-none text-gray-900 py-3 uppercase"
              >
                Piramide de Bird
              </h5>
            </div>
          </div>

          <div style="margin: 2.5rem 1rem 0rem">
            <img :src="birdPyramid" />
          </div>
        </div>
      </section>

      <!-- dados reais calculados -->
      <section class="me-2 mt-2 md:mt-0">
        <div
          class="max-w-sm w-full bg-white rounded-lg shadow-sm border block pb-2"
        >
          <div class="flex justify-between border-gray-200 border-b -mb-10">
            <div class="flex justify-center items-center w-full text-center">
              <h5
                class="text-xl font-bold leading-none text-gray-900 py-3 uppercase"
              >
                projeção teórica
              </h5>
            </div>
          </div>

          <div style="margin: 2.5rem 1rem 0rem">
            <PiramideDeBird />
          </div>
        </div>
      </section>

      <!-- dados reais calculados -->
      <section class="me-2 mt-2 md:mt-0">
        <div
          class="max-w-sm w-full bg-white rounded-lg shadow-sm border block pb-2"
        >
          <div class="flex justify-between border-gray-200 border-b -mb-10">
            <div class="flex justify-center items-center w-full text-center">
              <h5
                class="text-xl font-bold leading-none text-gray-900 py-3 uppercase"
              >
                projeção teórica
              </h5>
            </div>
          </div>

          <div style="margin: 2.5rem 1rem 0rem">
            <PiramideDeBird />
          </div>
        </div>

        <!-- <div class="max-w-sm w-full bg-white rounded-lg shadow-sm border block pb-2">
          <div class="flex justify-between border-gray-200 border-b -mb-10">
            <div class="flex justify-center items-center w-full text-center">
              <h5 class="text-xl font-bold leading-none text-gray-900 py-3 uppercase">
                real da unidade
              </h5>
            </div>
          </div>

          <div style="margin: 2.5rem 1rem 0rem;">
            <PiramideUnidade />
          </div>
        </div> -->
      </section>
    </div>

    <!-- gráfico em linha do ano -->
    <section class="mt-2 md:m-2">
      <div class="bg-white rounded-lg shadow-sm border w-full">
        <div class="flex justify-between border-gray-200 border-b -mb-10">
          <div class="flex justify-center items-center w-full text-center">
            <h5 class="text-xl font-bold leading-none text-gray-900 py-3">
              Estimativas de RCD's anual
            </h5>
          </div>
        </div>

        <!-- Bar Chart -->
        <div class="flex">
          <TheBarChartStatistics
            :labels="['RESOLVIDO', 'CONTROLADO', 'CANCELADO', 'NÃO CONTROLADO']"
            :colors="['#FFB7FF', '#FFB7FF', '#FFB7FF', '#FFB7FF']"
            :data="statistics"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import TheBarChartStatistics from "../../components/_partials/TheBarChartStatistics.vue";
import PiramideUnidade from "../../components/_partials/PiramideUnidade.vue";
import CardsStatistics from "../../components/_partials/CardsStatistics.vue";
import PiramideDeBird from "../../components/_partials/PiramideDeBird.vue";
import birdPyramid from "@/assets/piramide-de-bird.webp";
import { ChevronDownIcon } from "@heroicons/vue/24/outline";
import { computed, onMounted, ref } from "vue";
import { initFlowbite } from "flowbite";
import { dataRcd } from "../../store";

import RcdService from "../../service/rcd.service";
import { storeApp } from "@/store";

const daysInMonth = ref([]);
const currentDate = ref(new Date());
const monthsFilter = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

const statistics = computed(() => dataRcd.getters.getStatistics?.statistics);
const cards = computed(() => dataRcd.getters.getCardsVal);
const isMobile = computed(() => window.innerWidth < 768);
const monthYear = computed(() => {
  const month = currentDate.value.getMonth();
  const year = currentDate.value.getFullYear();
  return `${monthsFilter[month]} ${year}`;
});

async function nextMonth() {
  const month = currentDate.value.getMonth();
  if (month === 11) {
    currentDate.value = new Date(currentDate.value.getFullYear() + 1, 0, 1);
  } else {
    currentDate.value = new Date(currentDate.value.getFullYear(), month + 1, 1);
  }

  Promise.allSettled([
    await getStatistics({
      month: currentDate.value.getMonth() + 1,
      year: currentDate.value.getFullYear(),
    }),
  ]);

  updateDaysInMonth();
}

async function prevMonth() {
  const month = currentDate.value.getMonth();
  if (month === 0) {
    currentDate.value = new Date(currentDate.value.getFullYear() - 1, 11, 1);
  } else {
    currentDate.value = new Date(currentDate.value.getFullYear(), month - 1, 1);
  }

  Promise.allSettled([
    await getStatistics({
      month: currentDate.value.getMonth() + 1,
      year: currentDate.value.getFullYear(),
    }),
  ]);

  updateDaysInMonth();
}

async function getStatistics(params) {
  dataRcd.dispatch("setCardLoad", true);

  await RcdService.getDataCards(params?.month, params?.year)
    .then((res) => {
      dataRcd.dispatch("setCards", res.data);
    })
    .catch((err) => {
      return toast("Aviso", "Algo deu errado ao buscar dados do mês", "error");
    });

  dataRcd.dispatch("setCardLoad", false);
}

function updateDaysInMonth() {
  const year = currentDate.value.getFullYear();
  const month = currentDate.value.getMonth();
  const days = [];

  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const totalDays = new Date(year, month + 1, 0).getDate();

  for (let i = 0; i < (firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1); i++) {
    days.push({ date: null, label: "" });
  }

  for (let day = 1; day <= totalDays; day++) {
    days.push({
      date: new Date(year, month, day),
      label: day,
    });
  }

  daysInMonth.value = days;
}

onMounted(() => {
  initFlowbite();
});
</script>

<style scoped lang="scss">
.calendar-container {
  margin: -10px auto 0px;
  padding-bottom: -10px;
  border-radius: 8px;
  width: 100%;
  max-width: 320px;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  font-weight: bold;
}

.nav-button {
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}
</style>
